export class User {
    constructor(public username: string,
                public email: string,
                public phoneNumber: string,
                public givenName: string,
                public surName: string,
                public preferredName: string, // for student only
                public callistaPersonId: string,
                public sapEmployeeNumber: string,
                public isStudent: boolean,
                public isStaff: boolean,
                public isProspectiveStudent: boolean,
                public isAssessor: boolean,
                public faculties: any[],
                public isCentralAdmissions: boolean,
                public applicantId: string,
                public isMonashOnlineEducation: boolean) {
    }

    public getFullName(): string {
        if (this.preferredName) {
            return `${this.preferredName} ${this.surName}`;
        }
        return `${this.givenName} ${this.surName}`;
    }

    public isFacultyAdmin(): boolean {
        return (this.isStaff && this.faculties && this.faculties.length > 0) || this.isMonashOnlineEducation;
    }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/User.ts